<template lang="html">
  <div class="site-builder-header">
    <div>
      <transition name="fade" mode="out-in">
        <div key="back-tier" v-if="hasBackLink">
          <router-link class="builder-back-link" :to="backLink">
            <Sprite name="left-arrow"/>
            <span>Back a step</span>
          </router-link>
        </div>

        <div key="back-dash" v-else>
          <router-link class="builder-back-link" :to="{name: 'websites'}">
            <Sprite name="logo"/>
            <span>My Websites</span>
          </router-link>
        </div>
      </transition>
    </div>

    <div class="site-details">
      <h1>{{siteName}}</h1>

      <div class="domain-links">
        <a :href="`https://${siteDomain}`" target="_blank" class="domain-link">{{siteDomain}}</a>
        <router-link
          class="edit-domain-link"
          :to="{
            name: 'domain-settings',
            params: {
              companyId: this.companyId,
              siteId: this.siteId
            }
          }">
          <Sprite name="edit"/>
        </router-link>
      </div>
    </div>

    <div class="preview-modes">
      <Tooltip v-if="tipsActive" content="Toggle the preview mode for each device. Use the question mark to hide/show these tips"/>

      <button
        v-for="(mode, index) in previewModes"
        :key="`mode-${index}`"
        @click="changeMode(mode)"
        class="preview-size"
        :class="{ 'is-active': modeActive(mode)}">
        <Sprite :name="mode"/>
      </button>

      <button
        class="toggle-size"
        @click="showTips()"
        :class="{ 'is-active': tipsActive }">
        <Sprite name="help"/>
      </button>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'
import Tooltip from '@/components/Tooltip'

export default {
  name: 'SiteBuilderHeader',

  props: {
    siteName: String,
    siteDomain: String,
    companyId: String,
    hasBackLink: Boolean,
    backLink: Object,
    siteId: String,
    activeMode: String,
    tipsActive: Boolean,
    previewModes: Array
  },

  components: {
    Sprite,
    Tooltip
  },

  computed: {
    modeActive() {
      return (mode) => {
        return mode === this.activeMode
      }
    }
  },

  methods: {
    changeMode(mode) {
      this.$emit('changeMode', mode)
    },

    showTips() {
      this.$emit('showTips')
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.site-builder-header
  display: flex
  align-items: center
  justify-content: space-between
  position: relative
  padding: 0 $gap-medium
  color: #fff
  box-shadow: 0px 15px 10px 0px rgba(0, 0, 0, 0.05)
  opacity: 0
  animation: fadeIn .3s .1s ease-in-out
  animation-fill-mode: forwards
  transform: all .3s ease-in-out
  height: 60px
  z-index: 20

  @include themify($themes)
    background: themed('color-secondary')

  h1
    font-size: 10px
    color: #fff

    @include media($media-gt-medium)
      font-size: 12px

.site-details
  position: absolute
  left: 50%
  top: 50%
  text-align: center
  transform: translate(-50%, -50%)
  display: flex

.domain-links
  display: none

  @include media($media-gt-medium)
    display: inline-flex
    align-items: center
    margin-left: $gap-small

    a
      color: #fff
      transition: opacity .3s ease-in-out
      opacity: 0.25

      &:hover
        opacity: 1

  .domain-link
    font-size: 12px

  .edit-domain-link
    margin-left: $gap-x-small

    .sprite
      width: 15px
      height: 15px

.toggle-size
  background: none
  cursor: pointer
  border: none
  padding-left: 20px
  padding-right: 0

  @include media($media-gt-large)
    border-left: 1px solid rgba(255, 255, 255, 0.1)

  &:focus
    outline: none

  .sprite
    transition: all .3s ease-in-out

  &.is-active
    .sprite
      opacity: 1

.builder-back-link
  display: flex
  align-items: center
  color: #fff!important
  text-transform: uppercase

  span
    display: none

    @include media($media-gt-medium)
      display: block

  .sprite
    margin-right: 10px
</style>
